import React from 'react';
import { PlaceholderProps, components } from 'react-select';
import { FilterOptionType } from 'Book/shared';
import * as S from '../../styles';

export default (props: PlaceholderProps<FilterOptionType, true>) => {
  const count = props.getValue().length ?? 0;

  return (
    <components.Placeholder {...props}>
      <S.PlaceholderContainer>
        <S.PlaceholderLabel count={count}>{props.children}</S.PlaceholderLabel>
        {count ? <S.Count>{count}</S.Count> : null}
      </S.PlaceholderContainer>
    </components.Placeholder>
  );
};
